import { render, staticRenderFns } from "./home.vue?vue&type=template&id=724d74ef&scoped=true&"
import script from "./home.vue?vue&type=script&lang=ts&"
export * from "./home.vue?vue&type=script&lang=ts&"
import style0 from "./home.vue?vue&type=style&index=0&id=724d74ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724d74ef",
  null
  
)

export default component.exports